import { Link } from "@remix-run/react";

function LogoBar() {
  return (
    <Link
      to="/services"
      className="bg-white justify-center items-center gap-2 flex"
      aria-label="back to services page"
    >
      <img
        src="/img/logo_black.svg"
        className="w-8 h-8 relative"
        alt="hidsim_logo"
      />
      <img
        src="/img/logo_type_black.svg"
        alt="hidsim_logo_type"
        className="w-16 h-8 justify-center items-center flex"
      />
    </Link>
  );
}

export default LogoBar;
